<template>
    <a href="javascript:0;"
        data-toggle="popover"
        :title="getTitleText"
        data-trigger="hover"
        data-placement="bottom"
        data-html="true"
        :data-content="getPriceText">
        <i class="fal fa-info-circle"></i>
    </a>

</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'price-list-help',
    	props: {
    		servicename: String,
    		serviceid: [String, Number]
    	},
    	mounted: function() {
    		$('[data-toggle="popover"]').popover();
    	},
    	computed: {
    		getTitleText: function() {
    			return this.servicename;
    		},
    		getPriceText: function() {
    			//console.log('pricelist::' + this.servicename);
    			var priceText = '';
    			if (this.serviceid == '29047') {
    				priceText = 'Bei mehr als einem Haustier kontaktieren Sie bitte unser Urlaubstelefon unter 04921-8997-3203';
    			} else if (this.serviceid == '29030') {
    				priceText = 'Kinderbett mit Bettwäsche und Handtücher';
    			} else if (this.serviceid == '29034') {
    				priceText = 'Die Kleinkindausstattung besteht aus: Babykost- und Flaschenwärmer, Babyphone, Wickelauflage, Windeleimer und Trittschemel';
    			} else if (this.serviceid == '29054') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad sowie Bettwäsche';
    			} else if (this.serviceid == '30035') {
    				priceText = 'Die Hansestadt Wismar erhebt eine Übernachtungssteuer bei Privatreisen in Höhe von 5 % auf den Bruttoübernachtungspreis. Die Übernachtungssteuer wird in der Buchungsbestätigung ausgewiesen.';
    			} else if (this.serviceid == '62804') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad und Bettwäsche (die Betten sind bezogen).';
    			} else if (this.serviceid == '62834') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad und Bettwäsche (die Betten sind nicht bezogen).';
    			} else if (this.serviceid == '29055') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad und Bettwäsche (die Betten sind bezogen).';
    			}
    			/*if (this.servicename == 'Haustier') {
    				priceText = 'Bei mehr als einem Haustier kontaktieren Sie bitte unser Urlaubstelefon unter 04921-8997-3203';
    			} else if (this.servicename == 'Kinderbett') {
    				priceText = 'Kinderbett mit Bettwäsche und Handtücher';
    			} else if (this.servicename == 'Kleinkindausstattung') {
    				priceText = 'Die Kleinkindausstattung besteht aus: Babykost- und Flaschenwärmer, Babyphone, Wickelauflage, Windeleimer und Trittschemel';
    			} else if (this.servicename == 'Wäschepaket') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad sowie Bettwäsche';
    			} else if (this.servicename == 'Übernachtungssteuer') {
    				priceText = 'Die Hansestadt Wismar erhebt eine Übernachtungssteuer bei Privatreisen in Höhe von 5 % auf den Bruttoübernachtungspreis. Die Übernachtungssteuer wird in der Buchungsbestätigung ausgewiesen.';
    			} else if (this.servicename == 'Wäschepaket (Betten bezogen)') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad und Bettwäsche (die Betten sind bezogen).';
    			} else if (this.servicename == 'Wäschepaket (Betten nicht bezogen)') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad und Bettwäsche (die Betten sind nicht bezogen).';
    			} else if (this.servicename == 'Wäschepaket (inkl. Betten beziehen)') {
    				priceText = 'Das Wäschepaket besteht aus einem Handtuch, einem Badetuch, einem Duschvorleger pro Bad und Bettwäsche (die Betten sind bezogen).';
    			}*/


    			return priceText;
    		}
    	}
    };
</script>